import React, { useEffect } from 'react';
import { Button } from 'devextreme-react/button';
import { Modal } from '@core/components';

interface ImgViewerProps {
  hideModal: () => void;
  imgPath: string;
}

const ImgViewer = ({ hideModal, imgPath }: ImgViewerProps) => {
  const handleKeyDown = ({ code }: KeyboardEvent) => {
    if (code === 'Escape') {
      hideModal();
    }
  };

  useEffect(() => {
    (document.activeElement as HTMLElement).blur();
    window.addEventListener('keydown', handleKeyDown, true);

    return () => {
      window.removeEventListener('keydown', handleKeyDown, true);
    };
  }, []);

  return (
    <Modal onOutsideClick={hideModal}>
      <div className="img-viewer">
        <div className="img-viewer__content">
          <div>
            <Button
              width={36}
              height={36}
              onClick={hideModal}
              type="normal"
              icon="clear"
              stylingMode="text"
            />
          </div>
          <img src={imgPath} alt={imgPath} />
        </div>
      </div>
    </Modal>
  );
};

export default ImgViewer;
